export default __webpack_public_path__ + "static/Tek-Spinner-061fd00cd0785255b86206eddb87cfc5.gif";